import { AppState } from '../../../store/store'

export const selectBrukare = (state: AppState) => state.brukareReducer.data
export const selectBruLoading = (state: AppState) => state.brukareReducer.loading
